import React from 'react';
import { Modal } from 'react-bootstrap';
import closeIcon from '../../images/popups/upload/closeicon.png';
import '../../scss/popups/delete_user.scss';

function EnableDNS({show, handleClose, page}) {
    return (
        <>
            <Modal
                show={show}
                onHide={handleClose} className='enable-dns-popup'
                centered>
                <Modal.Body className='enable-dns-body'>
                    <div className='enable-dns-close-icon'>
                        <img src={closeIcon} onClick={handleClose}/>
                    </div>
                    {page == "websites" && <div className='enable-dns-header'>Please add subdomain in the domain Registrar</div>}
                    {page == "brand" && <div className='enable-brand-header'>Client portal is associated with this Brand.</div>
                    }
                    {page == "websites" && <div className='enable-dns-button'>
                        <button onClick={handleClose}>Done</button>
                    </div>}
                    {page == "brand" && <div className='enable-brand-button'>
                        <button onClick={handleClose}>Done</button>
                    </div>}
                </Modal.Body>
            </Modal>
        </>
    );
}

export default EnableDNS;